import * as React from "react";
import cn from "classnames";
import styles from "./button.module.scss";

interface IButtonProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  children: any;
  variant?: "default" | "white" | "invert" | "cta";
  href?: string;
  showEmojiAnyWay?: boolean
}

const variants: { [variant: string]: string } = {
  default: styles.button,
  white: styles.buttonWhite,
  invert: styles.buttonInvert,
  cta: styles.buttonCta
};

const Button = ({
  onClick,
  className,
  style,
  href,
  children,
  variant = "default",
  showEmojiAnyWay
}: IButtonProps) =>
  !href ? (
    <button
      onClick={() => onClick && onClick()}
      className={cn(styles.button, variants[variant], className)}
      style={style}
    >
      {children}
      {(variant === "cta" || showEmojiAnyWay) && (
        <span className={styles.emoji} role="img" aria-label="checkout">
          👉
        </span>
      )}
    </button>
  ) : (
    <a href={href}>
      <button
        onClick={() => onClick && onClick()}
        className={cn(styles.button, variants[variant], className)}
        style={style}
      >
        {children}
        {(variant === "cta" || showEmojiAnyWay) && (
          <>
            <span className={styles.emoji} role="img" aria-label="checkout">
              👉
            </span>
          </>
        )}
      </button>
    </a>
  );

export default Button;
